module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-52.5a49ac9b.svg";